define(function(require,exports,module){
	var	trim = /^\s+|\s+$/g,
		wsReduce=/\s+/g;

	return {
		// Use native String.trim function wherever possible
		trim : String.prototype.trim ? function(text){
               return  (text||"").trim();
            } : function( text ) {
    			return text == null ? "" : (text+"").replace( trim, "" );
		},
		ws : function( text ) {
			return (text||'').replace(wsReduce,' ');
		}
	}
});